import 'flag-icon-css/css/flag-icon.css';

import { Button, Checkbox, InputAdornment, TableCell, TableRow, TextField, Theme, Tooltip, WithStyles, createStyles, withStyles } from '@material-ui/core';
import { IconDefinition, faCheck, faSpinner, faTimesCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import React, { ChangeEvent, Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PhoneNumber from 'awesome-phonenumber';
import classnames from 'classnames';

export type PhoneNumberEnrolment = {
  key: string
  phoneNumber: PhoneNumber
  lastModified: number
  default: boolean
  fromDatabase: boolean
}

export const newEnrolment = () => {
  return ({
    key: new Date().getTime().toString(),
    phoneNumber: new PhoneNumber(""),
    sms: true,
    phone: true,
    default: false,
    lastModified: Date.now(),
    fromDatabase: false
  } as PhoneNumberEnrolment)
}

const styles = (theme: Theme) => createStyles({
  messageText: {
    textAlign: 'center',
    alignSelf: 'center',
    marginTop: theme.spacing()
  },
  input: {
    maxWidth: '15rem',
    alignSelf: 'center',
  },
})

type PhoneNumberInputState = {
  rawPhoneNumber: string
  messageText: string
  messageColor: string
  messageIcon: IconDefinition | null
  textFieldError: boolean
  loading: boolean
  dirty: boolean
}

class PhoneNumberInput extends Component<PhoneNumberInputProps, PhoneNumberInputState> {
  state = {
    rawPhoneNumber: (this.props.enrolment.phoneNumber.getNumber() || "").replace("+", ""),
    messageText: "",
    messageColor: "green",
    messageIcon: this.props.enrolment.fromDatabase ? faCheck : null,
    textFieldError: false,
    loading: false,
    dirty: !this.props.enrolment.fromDatabase,
  }

  onChange = (pne: PhoneNumberEnrolment) => {
    this.props.onChange(pne).then(saved => {
      if (!pne.phoneNumber.isValid())
        this.setState({
          messageText: "Please enter a valid international phone number",
          messageColor: 'red',
          messageIcon: faTimesCircle,
          textFieldError: true,
          loading: false,
        })
      /*else if(!pne.phoneNumber.isMobile() && pne.sms)
        this.setState({
          messageText: "This doesn't appear to be a mobile number",
          messageColor: 'orange',
          messageIcon: faExclamationTriangle,
          error: false
        })*/
      else {
        this.setState({ loading: true })

        this.props.onSave(pne).then(_ => {
          this.setState({
            messageText: "",
            messageColor: 'green',
            messageIcon: faCheck,
            textFieldError: false,
            loading: false,
            dirty: false,
          })
        }).catch(error => {
          console.error(error)
          this.setState({
            messageText: error.message,
            messageColor: 'red',
            messageIcon: faTimesCircle,
            textFieldError: false,
            loading: false
          })
        })
      }
    })
  }

  handlePhoneNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
    this.setState({
      rawPhoneNumber: event.target.value,
      dirty: true
    })

    this.onChange({
      ...this.props.enrolment,
      phoneNumber: new PhoneNumber("+" + event.target.value)
    } as PhoneNumberEnrolment)
  }

  handleToggleAttribute = (attribute: "default") => () => {
    const { enrolment } = this.props

    this.setState({
      dirty: true
    })

    let newEnrolment = {
      ...enrolment,
      [attribute]: !enrolment[attribute]
    } as PhoneNumberEnrolment

    this.onChange(newEnrolment)
  }

  handleDelete = () => {
    this.setState({ loading: true, dirty: true })
    this.props.onDelete(this.props.enrolment.fromDatabase).catch(error => {
      this.setState({ textFieldError: error.message, loading: false })
    })
  }

  render = () => {
    const { classes, enrolment } = this.props
    const { messageText, messageIcon, messageColor, textFieldError: error, rawPhoneNumber, loading } = this.state

    return (
      <TableRow>
        <TableCell>
          <Checkbox
            checked={enrolment.default}
            onChange={this.handleToggleAttribute('default')}
            value="default"
            disabled={loading}
            color="primary"
          />
        </TableCell>
        <TableCell>
          <TextField
            value={rawPhoneNumber}
            onChange={this.handlePhoneNumberChange}
            error={error ? true : false}
            className={classes.input}
            disabled={loading}
            InputProps={{
              startAdornment: <InputAdornment position="start">+</InputAdornment>,
              endAdornment: <InputAdornment position="end">
                <span className={classnames("flag-icon", enrolment.phoneNumber.isValid() ? `flag-icon-${enrolment.phoneNumber.getRegionCode().toLowerCase()}` : "flag-icon-hidden")}></span>
              </InputAdornment>
            }}
          />
        </TableCell>
        <TableCell>
          <Tooltip title="Delete">
            <Button onClick={this.handleDelete} disabled={loading}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </Button>
          </Tooltip>
        </TableCell>
        <TableCell>
          {loading ?
            <FontAwesomeIcon icon={faSpinner} />
            : messageIcon ?//error ?
              <Tooltip title={messageText}>
                <span><FontAwesomeIcon icon={messageIcon} style={{ color: messageColor }} /></span>
              </Tooltip>
              /*: !dirty ?
              <FontAwesomeIcon icon={faCheck} style={{ color: messageColor }} />*/
              : ""
          }
        </TableCell>
      </TableRow>
    )
  }
}

interface PhoneNumberInputProps extends WithStyles<typeof styles> {
  enrolment: PhoneNumberEnrolment
  onChange: (pn: PhoneNumberEnrolment) => Promise<boolean>
  className: string
  onDelete: (fromDatabase: boolean) => Promise<any>
  onSave: (pne: PhoneNumberEnrolment) => Promise<boolean>
}

export default withStyles(styles)(PhoneNumberInput)